import React from 'react';
import styled from 'styled-components';

const StyledHeader = styled.div`
  color: ${({ theme, Color }) => (Color ? Color : theme.colors.primaryColor)};
  font-family: ${({ theme }) => theme.fonts.headerFont};
  font-size: ${({ theme, size }) => theme.headers[size]};
  font-weight: normal;
  line-height: 1.2rem;
  ${({ center }) => center && 'text-align: center'};

  @media (max-width: 480px) {
    font-size: ${({ size }) => size === 'h1' && '50px'};
  }
  @media (max-width: 375px) {
    font-size: ${({ size }) => size === 'h1' && '40px'};
  }
`;

const Header = ({ children, size, ...props }) => {
  return (
    <StyledHeader as={`${size}`} size={size} {...props}>
      {children}
    </StyledHeader>
  );
};

export default Header;
